import { createContext, useState } from "react";

export const UserQrCodeContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [userQrCodes, setUserQrCodes] = useState([]);

    // Make the context object:
    const userQrCodeContext = {
        userQrCodes,
        setUserQrCodes,
    };

    // pass the value in provider and return
    return <UserQrCodeContext.Provider value={userQrCodeContext}>{children}</UserQrCodeContext.Provider>;
};

export const { Consumer } = UserQrCodeContext;
